import { isLocalhost } from 'Lib/is-localhost/is-localhost';

export class BasketWholesale {
    constructor(nomcode) {
        this._nomcode = nomcode;
        this._gulpReplacer = '/eksmo/_verstka';
    }

    static _checkPromise(data) {
        if (data.ok) {
            return Promise.resolve(data.json());
        }

        return Promise.reject(new Error(`Ошибка: ${data.status}`));
    }

    // Добавление книги в оптовую корзину на КК
    addCurrentBookPage() {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/wholesale-book-get-current.json` : '/ajax/opt/cart_add/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ nomcode: this._nomcode }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error('Ошибка при добавлении книги в оптовую корзину'));
    }

    // Получение информации о книге в оптовой корзине на КК
    getCurrentBookPage() {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/wholesale-book-get-current.json` : '/ajax/opt/book/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ nomcode: this._nomcode }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error('Ошибка при получении информации о книге в оптовой корзине'));
    }

    // Получение оптовой корзины
    getBasket() {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/basket_list_book.json` : '/ajax/opt/cart_get/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'GET',
                credentials: 'include',
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error('Ошибка загрузки корзины'));
    }

    // Оформление заказа
    orderBasket() {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/basket_order.json` : '/ajax/opt/order',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ create_order: true }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error('Ошибка при оформлении заказа в корзине'));
    }

    // Удаление всех книг из оптовой корзины
    clearBasket() {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/basket_list_book.json` : '/ajax/opt/cart_clear/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ all_clear: true }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error('Ошибка удалениях всех книг из корзины'));
    }

    // Удаление книги из оптовой корзины
    deleteBook(nomcodeDelete) {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/basket_list_book_delete.json` : '/ajax/opt/cart_delete/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ nomcode: nomcodeDelete }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error(`Ошибка удаления книги (${nomcodeDelete}) из корзины`));
    }

    // Изменение количества книги в корзине
    editCountBook(nomcodeEditCount, count) {
        return fetch(isLocalhost() ? `${this._gulpReplacer}/ajax/wholesale-book/basket_list_book.json` : '/ajax/opt/cart_edit/',
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({ nomcode: nomcodeEditCount, count }),
            })
            .then((data) => BasketWholesale._checkPromise(data))
            .catch(() => console.error(`Ошибка удаления книги (${nomcodeEditCount}) из корзины`));
    }
}